// extracted by mini-css-extract-plugin
export default {"badge":"role_vacancies_badge-module___badge___f0cb610f"};